module.exports = __webpack_public_path__ + "static/media/20ECE8.4b503c01.jpg";